import {
    defineStore
} from 'pinia'
import {
    ref,
    watch
} from 'vue'

export const useThemeStore = defineStore('theme', () => {
    const isDark = ref(localStorage.getItem('theme') === 'dark')

    const apply = () => {
        if (isDark.value) {
            document.documentElement.classList.add('dark')
        } else {
            document.documentElement.classList.remove('dark')
        }
        localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
    }

    const toggle = () => {
        isDark.value = !isDark.value
    }

    watch(isDark, apply, {
        immediate: true
    })

    return {
        isDark,
        toggle
    }
})